import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { rem } from '@utils';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Panel = styled.div(
  ({ theme }) => css`
    animation: ${slideUp} 600ms cubic-bezier(0.2, 0.05, 0.4, 1) forwards;
    background: ${theme.palette.common.white};
    border: 1px solid ${theme.palette.grey['200']};
    border-radius: 4px;
    overflow: hidden;
    width: 100%;
    will-change: transform, opacity;
  `
);

const Header = styled.header(
  ({ theme }) => `
  align-items: center;
  background: ${theme.palette.grey['100']};
  border-bottom: 1px solid ${theme.palette.grey['200']};
  display: flex;
  gap: ${rem(8)};
  padding: ${rem(12)} ${rem(16)};
`
);

const HeaderLabel = styled.span(
  ({ theme }) => `
  color: ${theme.palette.grey['600']};
  flex-grow: 1;
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(16)};
`
);

const Progress = styled.span(
  ({ theme }) => `
  color: ${theme.palette.grey['600']};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(16)};
  white-space: nowrap;
`
);

const CloseButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  color: ${({ theme }) => theme.palette.grey['600']};
  cursor: pointer;
  display: flex;
  padding: 0;
  transition: color 100ms ease;

  &:hover {
    color: ${({ theme }) => theme.palette.common.black};
  }
`;

const Body = styled.div`
  padding: ${rem(20)} ${rem(24)};
`;

const Question = styled.h5`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(24)};
  margin: 0 0 ${rem(16)};
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
`;

const Option = styled.div`
  margin-left: -${rem(4)};
  padding: ${rem(8)} 0;

  .MuiFormControlLabel-label {
    font-size: ${rem(14)};
    font-weight: 400;
    line-height: ${rem(16)};
  }
`;

const Footer = styled.footer(
  ({ theme }) => `
  align-items: center;
  border-top: 1px solid ${theme.palette.grey['200']};
  display: flex;
  gap: ${rem(8)};
  justify-content: space-between;
  padding: ${rem(12)} ${rem(16)};
`
);

const Hint = styled.span(
  ({ theme }) => `
  color: ${theme.palette.grey['500']};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(16)};
`
);

const Actions = styled.div`
  display: flex;
  gap: ${rem(8)};
`;

export default {
  Panel,
  Header,
  HeaderLabel,
  Progress,
  CloseButton,
  Body,
  Question,
  Options,
  Option,
  Footer,
  Hint,
  Actions
};
